/**
 * Importing necessary functions and middleware from Redux and redux-thunk.
 */
import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";

/**
 * Importing the rootReducer which combines all individual reducers.
 */
import reducers from "./reducers/index";

/**
 * Creating the Redux store by combining the rootReducer and applying middleware.
 * Redux Thunk middleware allows you to write action creators that return a function instead of an action.
 * This is useful for handling asynchronous operations in Redux.
 */
const store = createStore(
  reducers, // Combined rootReducer containing all reducers
  applyMiddleware(ReduxThunk) // Applying middleware, in this case, redux-thunk
);

export default store;
